import axios from "utils/interceptors";

export const login = async (formData) => {
  return await axios.post(`/auth/login`, formData);
};

export const loadUserByToken = async () => {
  return await axios.get(`/auth/me`);
};

export const verifyEmail = async (payload) => {
  return await axios.post("/auth/forgot-password", payload);
};

export const resetPassword = async (password, token) => {
  return await axios.post("/auth/reset-password", { password }, { params: { token } });
};
